import { GetHelpModalLazy } from '../src/GetHelpModalLazy.tsx';
export default GetHelpModalLazy;
